import { HistoryMessageItem, MessageStatusType, PServed, useIM } from '@wui/im'

import { chatModel } from '@/entities/messages'
import { useStoreLastReadEventIds } from '@/entities/room'


import { useCurrentUser } from '@/shared/composables/current-user'

const MARKABLE_MESSAGE_TYPES = ['IncomingMessageEvent', 'OutgoingMessageEvent', 'ConferencePublicIdentitySet'] as const

const MARK_AS_READ_DELAY_MS = 300

export const useAutoMarkAsReadIfExecutor = () => {
  const im = useIM()
  const { currentUser } = useCurrentUser()
  const { updateMessageStatus } = chatModel.useChatMessageStore()
  const storeLastReadEventIds = useStoreLastReadEventIds()

  const updateLocalReadStatus = (
    eventId: number,
    pServed: PServed,
    userId: string,
    rank: number,
    timestamp: number,
  ) => {
    updateMessageStatus(
      eventId,
      pServed,
      userId,
      MessageStatusType.READ,
      rank,
    )
    storeLastReadEventIds.updateLastReadEventId(
      pServed,
      userId,
      eventId,
      rank,
      timestamp,
    )
  }

  const isValidMessage = (message: HistoryMessageItem, pServed: PServed): boolean => {
    return !!(
      message.eventId &&
      pServed &&
      message.rank !== undefined &&
      message.rank !== null &&
      message.timestamp !== undefined &&
      message.timestamp !== null
    )
  }

  const isMarkableMessageType = (messageType: string | number): boolean => {
    return MARKABLE_MESSAGE_TYPES.includes(messageType as typeof MARKABLE_MESSAGE_TYPES[number])
  }

  return (message: HistoryMessageItem, pServed: PServed) => {
    const executor = (message.item as { executor?: string }).executor
    const userId = currentUser.value?.imLogin

    if (!executor || !userId || executor !== userId) {
      return
    }

    if (!isValidMessage(message, pServed)) return

    const { eventId, rank, timestamp } = message
    const messageType = message.item.type
    const isSystemEvent = !isMarkableMessageType(messageType)

    if (isSystemEvent) {
      updateLocalReadStatus(eventId, pServed, userId, rank, timestamp)
      return
    }

    setTimeout(() => {
      im.markAsRead({
        eventIdMarkedAsRead: eventId,
        to: pServed,
      })
        .then(result => {
          if (result) {
            updateLocalReadStatus(eventId, pServed, userId, rank, timestamp)
          }
        })
        .catch(error => {
          console.warn('autoMarkAsReadIfExecutor: Failed to mark as read', error, {
            eventId,
            pServed,
            messageType,
          })
        })
    }, MARK_AS_READ_DELAY_MS)
  }
}
